import React from 'react';
import { cn } from '@/utils/cn';

interface PageShellProps {
  /** Page title block. Build it with <PageHeader>. Stays fixed while the body scrolls. */
  header: React.ReactNode;
  /** Scrollable page body. */
  children: React.ReactNode;
  /** Tailwind max-width class, e.g. "max-w-5xl". Defaults to "max-w-5xl". */
  maxWidth?: string;
}

// The app shell's <main> already supplies the outer gutter (p-4 md:p-6), so the shell adds none of its own:
// no header band, no extra horizontal padding.
const PageShell: React.FC<PageShellProps> = ({ header, children, maxWidth = 'max-w-5xl' }) => (
  <div className="flex h-full flex-col">
    <div className="shrink-0 pb-5">
      <div className={cn('mx-auto w-full', maxWidth)}>{header}</div>
    </div>
    <div className="no-scrollbar min-h-0 flex-1 overflow-y-auto">
      <div className={cn('mx-auto w-full pb-6', maxWidth)}>{children}</div>
    </div>
  </div>
);

export default PageShell;
